import { useRef } from 'react'
import { IMappedProps, MapProps } from '../../interfaces/mappedProps'
import { getMappedValues, processMappedProps } from '../../utils'

const useMappedProps = <Map>(
  itemData: unknown = {},
  mappedProps: IMappedProps<Map> = {}
) => {
  const values = getMappedValues(itemData, mappedProps)
  const result = useRef<MapProps<Map>[]>([])
  const cachedValues = useRef('')
  const stringValues = String(values.map(({ value }) => value))
  const hasChanged = stringValues !== cachedValues.current

  // if values change, update cached data
  if (hasChanged) {
    cachedValues.current = stringValues
    result.current = processMappedProps(values, mappedProps)
    return result.current
  }

  // else return cached data
  return result.current
}

export default useMappedProps
